import React from 'react'
import i18n from '@pureartisan/simple-i18n'
import { makeStyles } from '@material-ui/core/styles'
import {
  Box,
  Typography,
  useTheme,
} from '@material-ui/core'
import clsx from 'clsx'

// Styles for component.
const useDemoChipStyles = makeStyles(theme => ({
  root: {
    whiteSpace: 'nowrap',

    '& .demo-name': {
      display: 'inline-block',
    },

    '& .demo-icon': {
      display: 'inline',
      fontSize: 11,
      position: 'relative',
      bottom: 1,
      paddingRight: theme.spacing(1),
      // fixes Chrome bug where ⚪️ becomes 🔳
      fontWeight: 'normal',
    },

    '&.inactive': {
      '& .demo-name': {
        color: theme.extras.variables.colors.textSubtle,
      },
      '& .demo-icon': {
        color: theme.extras.variables.colors.veryLightGray,
      },
    },
  },
}))

const DemoChip = ({
  demo,
  nameFormatter,
  text,
  className,
  clickHandler,
  isZip = false,
  inactive = false,
  nameVariant = 'body1',
  color,
}) => {
  // console.log({ color })
  const classes = useDemoChipStyles()
  const name = text
    ? text
    : nameFormatter
    ? nameFormatter(demo)
    : i18n.translate(`POP_${demo.toUpperCase()}`)

  const theme = useTheme()
  const handleClick = () =>
    clickHandler && clickHandler(demo)
  return (
    <Box
      className={clsx(
        classes.root,
        className,
        'demo-chip',
        {
          inactive,
          isZip,
        },
      )}
      onClick={handleClick}
    >
      <Box
        className={clsx(demo, 'demo-icon')}
        color={
          color ||
          (!isZip
            ? theme.extras.demos[demo]
            : theme.extras.variables.colors.zipYellow)
        }
      >
        {!isZip ? '⬤' : '◯'}
      </Box>
      <Typography
        className="demo-name"
        variant={nameVariant}
      >
        {name}
      </Typography>
    </Box>
  )
}

DemoChip.propTypes = {}

DemoChip.defaultProps = {}

export default DemoChip
